import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ContextProviders } from './context';


// Custom imports:
import Dialogs from './dialogs';
import { ApiView, Api_providerView, Api_provider_methodView, AuthView, Auth_logoutView, HomeView } from './pages';
import PrivateRoute from './PrivateRoute';


import './styles/main.scss';

function App() {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
          <title>{t('title')}</title>
          <meta name="description" content={t('description')} data-react-helmet="true" />
      </Helmet>
      <Router>
        <ContextProviders>
          <Switch>
            <Route exact path="/" component={AuthView} />
						<PrivateRoute exact path="/api" component={ApiView} />
<PrivateRoute exact path="/api/:params(.+)" component={ApiView} />
						<PrivateRoute exact path="/api_provider" component={Api_providerView} />
						<PrivateRoute exact path="/api_provider/:params(.+)" component={Api_providerView} />
						<PrivateRoute exact path="/api_provider_method" component={Api_provider_methodView} />
						<PrivateRoute exact path="/api_provider_method/:params(.+)" component={Api_provider_methodView} />
						<Route exact path="/auth" component={AuthView} />
						<Route exact path="/auth/:params(.+)" component={AuthView} />
						<Route exact path="/auth_logout" component={Auth_logoutView} />
						<Route exact path="/auth_logout/:params(.+)" component={Auth_logoutView} />
						<PrivateRoute exact path="/home" component={HomeView} />
						<PrivateRoute exact path="/home/:params(.+)" component={HomeView} />
						<Route exact path="*" component={AuthView} />
						
          </Switch>

					<Dialogs />
        </ContextProviders>
      </Router>
    </>
  );
}

export default App;
